
import api from '../api';

/**
 * Fetch all orders for the authenticated user.
 *
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getOrders = async () => {
  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/user/getOrders";

  try {
    const response = await api.get(endpoint);

    return response.data;
  } catch (error) {
    console.error('Error while fetching orders:', error);
    throw error;
  }
}

export default getOrders;
